import { RequestsByClientState, RequestsByClientActionTypes, REQUESTS_BY_CLIENT_REQUEST, REQUESTS_BY_CLIENT_SUCCESS, REQUESTS_BY_CLIENT_FAILURE } from 'store/reducers/lodgingRequest/get-requests-by-client/types';

const defaultState: RequestsByClientState = {
  isLoading: false,
  errorMessage: ""
};

export default function requestsByClient(state = defaultState, action: RequestsByClientActionTypes): RequestsByClientState {
  switch (action.type) {
    case REQUESTS_BY_CLIENT_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case REQUESTS_BY_CLIENT_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case REQUESTS_BY_CLIENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};
